/* eslint-disable import/no-anonymous-default-export */
import { useEffect } from 'react'
import liveClassRepository from '../repositories/liveClassRepository'
import { useAppSelector } from '../store/hooks'
import { useNavigate } from 'react-router-dom'

function useGetLiveClass() {
	const {
		auth: { user },
	} = useAppSelector((state) => state)

	const { data, isLoading, refetch } = liveClassRepository.useGetQuery({
		userId: user?.id || 0,
	})

	useEffect(() => {
		let intervalId: NodeJS.Timeout | number | undefined

		if (data && data?.total > 0) {
			intervalId = setInterval(() => {
				refetch()
			}, 60000) // Polling a cada 60 segundos
		}

		return () => {
			if (intervalId) {
				clearInterval(intervalId)
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [data?.total])

	return { data, isLoading }
}

function useGetLiveClassByCohort() {
	const {
		auth: { user },
		matriculate: { classSelect },
	} = useAppSelector((state) => state)

	const navigate = useNavigate()

	useEffect(() => {
		if (!classSelect?.curso_id) {
			if (user?.modo_curso_unico) {
				navigate('/curso')
			} else {
				navigate('/')
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [classSelect])

	const turmaId = Number(classSelect?.id)
	const userId = user?.id || 0

	const { data, isLoading, refetch } = liveClassRepository.useGetByCohortQuery(
		{ userId, turmaId },
		{ skip: !turmaId }
	)

	useEffect(() => {
		let intervalId: NodeJS.Timeout | number | undefined

		if (data && data?.total > 0) {
			intervalId = setInterval(() => {
				refetch()
			}, 60000) // Polling a cada 60 segundos
		}

		return () => {
			if (intervalId) {
				clearInterval(intervalId)
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [data?.total])

	return { data, isLoading }
}

function useFeedbackMutation() {
	const [_feedbackLiveClass, { isLoading, isSuccess, isError }] =
		liveClassRepository.useFeedbackLiveClassMutation()

	async function execute(body: {
		aula_id: number
		happened: boolean
		feedback?: string
		rating?: number
		tags?: string[]
	}) {
		try {
			await _feedbackLiveClass(body)
		} catch (error) {
			console.error(error)
		}
	}

	return { execute, isLoading, isSuccess, isError }
}

export default {
	getLiveClass: useGetLiveClass,
	getLiveClassByCohort: useGetLiveClassByCohort,
	feedbackLiveClass: useFeedbackMutation,
}
